// https://example.com/form-page/?color=red
// JS:
const params = new URLSearchParams(window.location.search);
const fotorichtung = params.get('fotorichtung');
if (fotorichtung) {
  const radio = document.querySelector(
    `input[name="fotorichtung"][value="${fotorichtung}"]`,
  );
  if (radio) {
    radio.checked = true;
  }
}
